<template>
    <svg class="step-indicator" viewBox="0 0 160 50">
        <g transform="translate(20, 25)" class="develop" :class="{ active: (step == 1)}">
            <circle r="20"></circle>
            <text text-anchor="middle" dy="7">1</text>
        </g>
        <g transform="translate(80, 25)" class="share" :class="{ active: (step == 2)}">
            <circle r="20"></circle>
            <text text-anchor="middle" dy="7">2</text>
        </g>
        <g transform="translate(140, 25)" class="contact" :class="{ active: (step == 3)}">
            <circle r="20"></circle>
            <text text-anchor="middle" dy="7">3</text>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "StepIndicator",
        props: {
            'step': {
                type: Number,
                default: 1
            }
        }
    }
</script>